import React from "react";
import BaseTable from "components/ui_components/table/BaseTable";
import { yesNoAccessor } from "utils/accessors";

const tableColConfig = [
  {
    id: "address",
    label: "Address",
    accessor: (d) =>
      `${d.patientAddr1 ? d.patientAddr1 : ""}${
        d.patientAddr2 ? ", " + d.patientAddr2 : ""
      }${d.patientCity ? ", " + d.patientCity : ""}${
        d.patientState ? ", " + d.patientState : ""
      }${d.patientZip ? ", " + d.patientZip : ""}${
        d.patientCountry ? ", " + d.patientCountry : ""
      }`,
  },
  {
    id: "isDiabetic",
    label: "Diabetic",
    accessor: (d) => yesNoAccessor(d, "isDiabetic"),
  },
  {
    id: "isFamilyHistory",
    label: "Fam. HX of MI",
    accessor: (d) => yesNoAccessor(d, "isFamilyHistory"),
  },
];

export default function HistorySubTable({ parentRow }) {
  return (
    <BaseTable
      columns={tableColConfig}
      isSubTable={true}
      showSelect={false}
      showPagination={false}
      rows={[parentRow]}
    />
  );
}
